import { render, staticRenderFns } from "./WarrantyStatusBadge.vue?vue&type=template&id=3b5f9b62"
import script from "./WarrantyStatusBadge.vue?vue&type=script&lang=js"
export * from "./WarrantyStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports